import { NavigationTranslationType, ProfileTranslationType, ErrorsTranslationType, CommonTranslationType } from "../../features/types";

// Remove nested structure type and export a flatter object structure
export const common = {
  navigation: {
    dashboard: "Dashboard",
    profile: "Profile",
    signOut: "Sign Out",
    upgradeRequired: "Upgrade Required",
    basicSubscriptionRequired: "Basic subscription required",
    premiumSubscriptionRequired: "Premium subscription required"
  },
  profile: {
    title: "Profile",
    dangerZone: "Danger Zone",
    deleteAccount: "Delete Account",
    confirmDelete: "Confirm Delete",
    deleteWarning: "Are you sure you want to delete your account? This action cannot be undone.",
    confirmDeleteButton: "Delete Account",
    accountDeleted: "Account Deleted",
    accountDeletedMessage: "Your account has been successfully deleted."
  },
  cancel: "Cancel",
  delete: "Delete",
  deleteConfirmation: "Confirm Deletion",
  deleteConfirmationMessage: "Are you sure you want to delete",
  confirm: "Confirm",
  errors: {
    error: "Error",
    notFound: "Page not found",
    deleteAccountError: "There was an error deleting your account. Please try again.",
    loadStoryError: "Failed to load the story. Please try again.",
    loadCharactersError: "Failed to load characters. Please try again.",
    summaryError: "Error generating summary. Please try again."
  }
};
